import { cn } from '@/lib/utils'

/**
 * Figma (node 64:249):
 * Color: bg-accent (#f5f5f5), animate-pulse
 * Circle: rounded-full (e.g. avatar placeholder size-[40px])
 * Rectangle: rounded-md (8px) (e.g. text line h-[16px] w-[150px])
 */
export interface IntuiSkeletonProps {
  shape?: 'rectangle' | 'circle'
  width?: string
  height?: string
  className?: string
}

function IntuiSkeleton({ shape = 'rectangle', width, height, className }: IntuiSkeletonProps) {
  return (
    <div
      className={cn('animate-pulse bg-accent', shape === 'circle' ? 'rounded-full' : 'rounded-md', className)}
      style={{ width, height }}
      aria-hidden="true"
    />
  )
}

export { IntuiSkeleton }
